import React, { FC, PropsWithChildren, useRef, useState } from 'react';

import { fc } from 'i18n';
import { ReactPortal } from 'components/molecules/react-portal';

import styles from './styles.module.css';

interface ITooltipProps {
  text: string;
  isNoTranslate?: boolean;
  className?: string;
}

export const Tooltip: FC<PropsWithChildren<ITooltipProps>> = ({ children, text, isNoTranslate, className }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState<Record<string, number>>({ top: 0, left: 0 });

  const onMouseOver = () => {
    if (wrapperRef.current) {
      const { top, bottom, left, right } = wrapperRef.current.getBoundingClientRect();

      setPosition({ top: bottom - 2, left: right - 5 });
      setIsVisible(true);
    }
  };

  const onMouseOut = () => setIsVisible(false);

  return (
    <div ref={wrapperRef} className={className || ''} onMouseOut={onMouseOut} onMouseOver={onMouseOver}>
      {children}
      <ReactPortal>
        {isVisible && text ? (
          <div className={styles.wrapper} style={{ ...position }}>
            {isNoTranslate ? text : fc(text)}
          </div>
        ) : (
          <div />
        )}
      </ReactPortal>
    </div>
  );
};
